import React from 'react';
import { flowRight as compose } from 'lodash';
import { Link } from 'react-router-dom';

import s from './ExportsOverviewScreen.module.scss';
import withAuthentication from '../Auth/AuthenticationWrapper';
import withInterestTestResults, {
  itestResultsType,
} from '../HomeScreen/DataWrappers/InterestTestResultsWrapper';
import { checkIfTestResultsAreInvalid } from '../HomeScreen/DataWrappers/TestCompletionRequiredWrapper';
import ContentBody from '../ContentBody';
import Header from '../Header';
import Footer from '../Footer';
import getAssetLink from '../../util/getAssetLink';
import { ROUTE_PREFIX } from '../../constants/router';
import {
  ItestExportSnapshot,
  getExportSnapshots,
} from '../../util/exportSnapshots';

function formatTimestamp(timestamp: number): string {
  const date = new Date(timestamp);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

interface ExportsOverviewScreenProps {
  loggedMode: string;
  meData?: any;
  userItestResults?: itestResultsType;
}

interface ExportsOverviewScreenState {
  snapshots: ItestExportSnapshot[];
}

class ExportsOverviewScreen extends React.Component<
  ExportsOverviewScreenProps,
  ExportsOverviewScreenState
> {
  static defaultProps = {
    meData: null,
    userItestResults: null,
  };

  constructor(props: ExportsOverviewScreenProps) {
    super(props);

    this.state = {
      snapshots: getExportSnapshots().sort((a, b) => b.timestamp - a.timestamp),
    };
  }

  render() {
    const { loggedMode, meData, userItestResults } = this.props;
    const { snapshots } = this.state;

    const testResultsInvalid = checkIfTestResultsAreInvalid(userItestResults);
    const finishedTest = !testResultsInvalid;

    return (
      <div className={s.exportsOverviewContainer}>
        <Header />
        <ContentBody>
          <div className={s.overviewHeader}>
            <h2>Deine Exporte</h2>
          </div>
          {snapshots.length === 0 ? (
            <p className={s.emptyText}>Du hast noch keinen Export gestartet.</p>
          ) : (
            <div className={s.list}>
              {snapshots.map((snapshot) => (
                <Link
                  key={snapshot.timestamp}
                  className={s.row}
                  to={`${ROUTE_PREFIX}/export/${snapshot.timestamp}`}
                >
                  <span className={s.rowText}>
                    {formatTimestamp(snapshot.timestamp)}
                  </span>
                  <img
                    className={s.rowArrow}
                    src={getAssetLink('arrow_right.png')}
                    alt=""
                  />
                </Link>
              ))}
            </div>
          )}
        </ContentBody>
        <Footer
          loggedMode={loggedMode}
          meData={meData}
          finishedTest={finishedTest}
        />
      </div>
    );
  }
}

export default compose(
  withAuthentication,
  withInterestTestResults,
)(ExportsOverviewScreen);
